import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
import Dashboard from './pages/Dashboard';
import UserList from './pages/UserList';
import OrganizationList from './pages/OrganizationList';
import InvoiceGenerator from './pages/InvoiceGenerator';
import OpenCallList from './pages/OpenCall';
import ReviewList from './pages/Reviews';
import SubscribersList from './pages/Subscribers';
import ContactFormSubmissionsList from './pages/ContactFormSubmissions';
import ContactUsSubmissions from './pages/ContactUsSubmissions';
import PlansList from './pages/Plans';
import CouponsList from './pages/Coupons';
import PaymentsList from './pages/Payments';
import UsersPlansList from './pages/UsersPlans';
import LogEntryList from './pages/LogEntry';
import ProtectedRoute from './protectedRoute/ProtectedRoute';
import AdminLogin from './pages/Login';
import AdminLogout from './pages/Logout';
import ArtistTemplateSelector from './pages/ArtistTemplateSelector';
import CampaignAnalytics from './pages/CampaignAnalytics';
import ArtistOfTheMonth from './pages/ArtistOfTheMonth';
import ArtistInterviewsList from './pages/ArtistInterviews';
import InvoiceList from './pages/Invoices';
import Scraper from './pages/Scraper';
import IpLookup from './pages/IpLookup';
import BackgroundTaskLogs from './pages/BackgroundTaskLogs';
import ApiLogs from './pages/ApiLogs';
import EmailEvents from './pages/EmailEvent';
import EmailEventDetail from "./pages/EmailEventDetail";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CronTemplatesPage from "./pages/cronTemplates/CronTemplatesPage"

import CronManager from './pages/CronManager';
import ScraperCategories from './pages/ScraperCategories';
import AnalyticsDashboard from "./pages/AnalyticsDashboard";
import CountryPaymentGateways from "./pages/CountryPaymentGateways";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('access')); // Track authentication state
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  useEffect(() => {
    // Update authentication state when localStorage changes
    const handleStorageChange = () => {
      setIsAuthenticated(!!localStorage.getItem('access'));
    };
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('access');
    localStorage.removeItem('refresh');
    setIsAuthenticated(false); // Update authentication state
  };

  return (
    <Router>
      <div className="flex">
        {isAuthenticated && (
          <Sidebar isOpen={isSidebarOpen} toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
        )}
        <div
          className={`flex-1 flex flex-col min-h-screen transition-all duration-300 ${isSidebarOpen && isAuthenticated ? 'ml-64' : 'ml-16'
            }`}
        >
          {isAuthenticated && <Header toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />}
          <main className="flex-1 p-4 mt-16 mb-16 bg-gray-100 overflow-auto">
            <Routes>
              <Route path="/login" element={<AdminLogin />} />
              <Route path="/logout" element={<AdminLogout onLogout={handleLogout} />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route path="/analytics" element={<AnalyticsDashboard />} />
              {/* Other protected routes */}
              <Route path="/users" element={<ProtectedRoute><UserList /></ProtectedRoute>} />
              <Route path='/artist-of-the-month' element={<ProtectedRoute><ArtistOfTheMonth /></ProtectedRoute>} />
              <Route path='/artist-interviews' element={<ProtectedRoute><ArtistInterviewsList /></ProtectedRoute>} />
              <Route path="/organizations" element={<ProtectedRoute><OrganizationList /></ProtectedRoute>} />
              <Route path="/open-calls" element={<ProtectedRoute><OpenCallList /></ProtectedRoute>} />
              <Route path="/reviews" element={<ProtectedRoute><ReviewList /></ProtectedRoute>} />
              <Route path="/subscribers" element={<ProtectedRoute><SubscribersList /></ProtectedRoute>} />
              <Route path="/contact-form-submissions" element={<ProtectedRoute><ContactFormSubmissionsList /></ProtectedRoute>} />
              <Route path="/contact-us-submissions" element={<ProtectedRoute><ContactUsSubmissions /></ProtectedRoute>} />
              <Route path="/plans" element={<ProtectedRoute><PlansList /></ProtectedRoute>} />
              <Route path="/coupons" element={<ProtectedRoute><CouponsList /></ProtectedRoute>} />
              <Route path="/payments" element={<ProtectedRoute><PaymentsList /></ProtectedRoute>} />
              <Route path="/country-payment-gateways" element={<ProtectedRoute><CountryPaymentGateways /></ProtectedRoute>}/>
              <Route path="/users-plans" element={<ProtectedRoute><UsersPlansList /></ProtectedRoute>} />
              <Route path="/log-entries" element={<ProtectedRoute><LogEntryList /></ProtectedRoute>} />
              <Route path="/invoice-generator" element={<ProtectedRoute><InvoiceGenerator /></ProtectedRoute>} />
              <Route path="/all-invoices" element={<ProtectedRoute><InvoiceList /></ProtectedRoute>} />
              <Route path="/iplookup" element={<ProtectedRoute><IpLookup /></ProtectedRoute>} />
              <Route path="/scraper" element={<ProtectedRoute><Scraper /></ProtectedRoute>} />
              <Route path="/scraper-categories" element={<ProtectedRoute><ScraperCategories /></ProtectedRoute>} />
              <Route path="/campaign-analytics" element={<ProtectedRoute><CampaignAnalytics /></ProtectedRoute>} />
              <Route path="/user-email-marketing" element={<ProtectedRoute><ArtistTemplateSelector /></ProtectedRoute>} />
              <Route path="/background-task-logs" element={<ProtectedRoute><BackgroundTaskLogs /></ProtectedRoute>} />
              <Route path="/api-logs" element={<ProtectedRoute><ApiLogs /></ProtectedRoute>} />

              <Route path="/email-events" element={<EmailEvents />} />
              <Route path="/email-events/:id" element={<EmailEventDetail />} />

              <Route path="/cron-manager" element={<CronManager />} />

              <Route path="/admin/cron-templates/featured" element={<CronTemplatesPage />} />

            </Routes>
            <ToastContainer position="top-right" />
          </main>
          {isAuthenticated && <Footer />}
        </div>
      </div>
    </Router>
  );
}

export default App;